import PropTypes from 'prop-types'
import React from 'react'

import {
  Wrapper,
  DynamicImageStyled,
  DiscountLabel,
  LabelValue,
} from './styles'

const BAboutFirstBlockRussianBox = ({ path, discount, labelTheme }) => (
  <Wrapper>
    <DynamicImageStyled
      image={`${path}/biome-flying-new`}
      imageSizes={{ xs: 420, md: 850 }}
      imageType="png"
      fitOption={'contain'}
      alt={'Microbiome Box'}
    />
    {discount > 0 && (
      <DiscountLabel bg={labelTheme.bg} textColor={labelTheme.text}>
        <LabelValue dangerouslySetInnerHTML={{ __html: `-${discount}%` }} />
      </DiscountLabel>
    )}
  </Wrapper>
)

BAboutFirstBlockRussianBox.propTypes = {
  path: PropTypes.string.isRequired,
  discount: PropTypes.number,
  labelTheme: PropTypes.shape({
    bg: PropTypes.string,
    text: PropTypes.string,
  }),
}

export default BAboutFirstBlockRussianBox
